import { useCallback } from 'react'

import { useChatContext } from '../../ChatContext/ChatContext.js'
import { ComposerSubmitParams } from '../../types.js'
import { ChatComposerContainer } from '../ChatComposerContainer.js'

import { NoMemberSelected } from './NoMemberSelected.js'

interface Props {
  memberId: string
}

export const NewDirectChat = ({ memberId }: Props) => {
  const { sendMessageToNewChat, isSendingMessage } = useChatContext()

  const handleComposerSubmit = useCallback(
    async ({ isSendingGiphy, giphyFiles }: ComposerSubmitParams) => {
      await sendMessageToNewChat({
        recipientId: memberId,
        isSendingGiphy,
        giphyFiles,
      })
    },
    [sendMessageToNewChat, memberId],
  )

  return (
    <div className="grid grid-rows-[1fr_auto] grid-cols-1 overflow-hidden h-full w-full">
      <NoMemberSelected />
      <div className="relative min-h-[8rem] flex-shrink-0 w-full">
        <ChatComposerContainer
          disabled={!memberId || isSendingMessage}
          onComposerSubmit={handleComposerSubmit}
        />
      </div>
    </div>
  )
}
